import { useEffect, useRef, useState } from 'react';
import fallback from './../../assets/fallback-logo.png';
import config from '../../constants/config.js';
import "./../../styles/Sidebar.css";
import { useAuth } from '../../context/AuthProvider.js';

function StoreSelector() {
    const { logout } = useAuth();
    const [ availableStores , setAvailableStores ] = useState( [] );
    const [ localStorageAvailableStores , setLocalStorageAvailableStores ] = useState( getSavedStoreList() );
    const [ singleSelectedStore , setSingleSelectedStore ] = useState( getSingleSelectedStore() );
    const [ multiSelectedStore , setMultiSelectedStore ] = useState( getMultiSelectedStore() );
    const [ currentStoreMode , setStoreMode ] = useState( getMode() );

    const [ isOpen, setIsOpen ] = useState(false);
    const [ componentLoading , setLoading ] = useState( false );
    const menuRef = useRef( null );

    useEffect( () => {
        async function loadData() {
            setLoading( true );

            try {
                const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/shops`;
                const requestSettings = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                const response = await fetch( url , requestSettings );
                const data = await response.json();

                if ( data?.shopList != null && data?.shopList?.length > 0 ) {
                    setAvailableStores( data.shopList );

                    let changed = false;
                    if ( JSON.stringify( localStorageAvailableStores ) !== JSON.stringify(data.shopList) ) {
                        changed = true;
                        setLocalStorageByKey( 'all_stores' , JSON.stringify( data.shopList ) )
                        setLocalStorageAvailableStores( data.shopList );
                    }

                    // set a default when null, apply default when a change occurs in the loaded dataset
                    if ( singleSelectedStore === null ) {
                        setLocalStorageByKey( 'single_store_selected' , JSON.stringify( data.shopList[0] ) );
                        setSingleSelectedStore( data.shopList[0] );
                    } else {
                        if ( changed ) {
                            setLocalStorageByKey( 'single_store_selected' , JSON.stringify( data.shopList[0] ) );
                            setSingleSelectedStore( data.shopList[0] );
                        }
                    }

                    if ( multiSelectedStore === null ) {
                        setLocalStorageByKey( 'multi_stores_selected' , JSON.stringify( [ data.shopList[0] ] ) );
                        setMultiSelectedStore( [ data.shopList[0] ] );
                    } else {
                        if ( changed ) {
                            setLocalStorageByKey( 'multi_stores_selected' , JSON.stringify( [ data.shopList[0] ] ) );
                            setMultiSelectedStore( [ data.shopList[0] ] );
                        }
                    }

                    if ( currentStoreMode === null ) {
                        setLocalStorageByKey( 'store_selection_mode' , "SINGLE" );
                        setStoreMode( "SINGLE" );
                    }
                }
            } catch ( error ) {
                console.log( error );
            } finally {
                setLoading( false );
            }
        }

        loadData();
    } , []);

    if ( componentLoading ) {
        return( 
            <div className="store-selector-skeleton"></div>
        )
    }

    function toggleMenu() {
        setIsOpen( !isOpen );
    }

    function getSingleSelectedStore() {
        let store = JSON.parse( localStorage.getItem( 'single_store_selected' ) ) || null;
        return store;
    }

    function setLocalStorageByKey( key , value ) {
        localStorage.setItem( key, value );
        return;
    }

    function getMultiSelectedStore() {
        let stores = JSON.parse( localStorage.getItem( 'multi_stores_selected' ) ) || null;
        return stores;
    }

    function getMode() {
        let mode = localStorage.getItem( 'store_selection_mode' );
        return mode;
    }

    function getSavedStoreList() {
        let savedList = JSON.parse( localStorage.getItem("all_stores" ) ) || [];
        return savedList;
    }

    function selectStore( mode , selectedIndex , alreadySelected ) {
        const storeSelected = availableStores[ selectedIndex ];
        if ( mode === 'SINGLE' ) {
            setLocalStorageByKey( 'single_store_selected' , JSON.stringify( storeSelected ) );
            setSingleSelectedStore( storeSelected );
        } else if ( mode === 'MULTI' ) {
            let finalArray = [];
            if ( alreadySelected ) {
                if ( multiSelectedStore.length <= 1 ) {
                    // dont allow deselect
                    finalArray = multiSelectedStore;
                } else {
                    // insert all but storeSelected
                    for ( let i = 0; i < multiSelectedStore.length; i++ ) {
                        if ( storeSelected?.shop === multiSelectedStore[i]?.shop ) {
                            continue;
                        }

                        finalArray.push( multiSelectedStore[i] );
                    }
                }
            } else {
                // select store
                finalArray = multiSelectedStore.concat( [ storeSelected ] );
            }

            setLocalStorageByKey( 'multi_stores_selected' , JSON.stringify( finalArray ) );
            setMultiSelectedStore( finalArray );
        }

        // If mode == "SINGLE",
        // update the selected store value with new store info
        
        // if mode == "MULTI"
            // if already selected, remove
            // if not selected add
            // update the selected store value with new stores info
    }

    return( 
        <div className="store-selector-global">
            <div onClick={toggleMenu} className="store-selector-wrapper">
                <div className="store-selector-content">
                    <div className="logo-wrapper">
                        <img 
                            className="logo"
                            src={ currentStoreMode === 'SINGLE' ? ( singleSelectedStore?.logo_url || fallback ) : fallback }
                            alt="site-logo"
                            loading="lazy"
                        />
                    </div>
                    <div className="selected-store">
                        <div className="store-nickname">{currentStoreMode === 'SINGLE' ? ( singleSelectedStore?.nickname || '' ) : "Multiple Stores" }</div>
                        <div className="store-shop-url">
                            { currentStoreMode === 'SINGLE' &&
                                <span>
                                    {singleSelectedStore?.shop || ''}
                                </span>
                            }

                            { currentStoreMode === 'MULTI' &&
                                <span>
                                    { multiSelectedStore?.length } Store(s) selected
                                </span>
                            }
                            
                        </div>
                    </div>
                </div>
                <div className="actions" ref={menuRef}>
                    <div className="expand-opitons">
                        <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.91542 0.0807728C4.04724 -0.0269243 4.23588 -0.0269243 4.36998 0.0807728L8.00639 3.0138C8.16321 3.13983 8.18821 3.37126 8.06321 3.52937C7.9382 3.68748 7.70866 3.71269 7.55184 3.58666L4.1427 0.836944L0.733565 3.58666C0.576745 3.71269 0.347196 3.68748 0.222194 3.52937C0.0971928 3.37126 0.122193 3.13983 0.279013 3.0138L3.91542 0.0807728ZM0.279013 7.9862C0.122193 7.86017 0.0971928 7.62874 0.222194 7.47063C0.347196 7.31252 0.576745 7.28731 0.733565 7.41334L4.1427 10.1631L7.55184 7.41334C7.70866 7.28731 7.9382 7.31252 8.06321 7.47063C8.18821 7.62874 8.16321 7.86017 8.00639 7.9862L4.36998 10.9192C4.23816 11.0269 4.04952 11.0269 3.91542 10.9192L0.279013 7.9862Z" fill="black"/>
                        </svg>
                    </div>
                </div>
            </div>

            { isOpen && 
                <div className="store-selection-menu">
                    <div className="store-options">
                        { availableStores?.length > 0 && availableStores.map( ( store , index ) => {
                            let selected = false;
                            let classes = "store-option ";
                            if ( currentStoreMode === 'SINGLE' ) {
                                if ( store?.shop === singleSelectedStore?.shop ) {
                                    selected = true;
                                    classes += "selected";
                                }
                            } else if ( currentStoreMode === 'MULTI' ) {
                                for ( let i = 0; i < multiSelectedStore.length; i++ ) {
                                    if ( store?.shop === multiSelectedStore[i]?.shop ) {
                                        selected = true;
                                        classes += "selected";
                                        break;
                                    }
                                }
                            }
                            

                            return(
                                <div onClick={ () => { selectStore( currentStoreMode , index , selected ) } } className={classes} key={index}>
                                    <div>
                                        <img 
                                            className="logo"
                                            src={ store?.logo_url || fallback }
                                            alt="site-logo"
                                            loading="lazy"
                                        />
                                    </div>
                                    <div className="info">
                                        <span className="store-nickname">{ store?.nickname || '' }</span>
                                        <span className="store-shop-url">{ store?.shop || '' }</span>
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    <div className="store-selection-menu-actions">
                        <div className="store-selection-modes">
                            <h2>Store selection settings</h2>
                            <div className="column">
                                <button onClick={ () => { 
                                    setStoreMode( "SINGLE" ) 
                                    setLocalStorageByKey( 'store_selection_mode' , "SINGLE" );
                                }} className={ currentStoreMode === 'SINGLE' ? 'selected' : '' }>
                                    Select One
                                    <svg width={10} height={10} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                        <path fill="#fff" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                    </svg>
                                </button>  

                                <button onClick={ () => { 
                                    setStoreMode( "MULTI" ) 
                                    setLocalStorageByKey( 'store_selection_mode' , "MULTI" );
                                }} className={ currentStoreMode === 'MULTI' ? 'selected' : '' }>
                                    Select Multiple
                                    <svg width={10} height={10} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                        <path fill="#fff" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <hr />
                        <div className="store-selection-misc">
                            <button onClick={ () => { toggleMenu(); window.location.reload() } }>Apply Changes</button>
                            <button onClick={ () => { logout() }} className="logout">Logout</button>
                        </div>
                    </div>
                </div>
            }

        </div>
    );
}

export default StoreSelector;